import React,{ Component, useState, useRef,useEffect } from "react"
import { useProject } from "../Providers"
import axios from "axios"
import style from "../common/setting.module.scss"
//import PropTypes from "prop-types";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import ControlPanel from "../ControlPanel"

//import DatePicker from "react-datepicker";
//import "react-datepicker/dist/react-datepicker.css";
//import styled from "styled-components";
import LedEditor from "./lededitor";
const iconv = require('iconv-lite');
//import { ko } from 'date-fns/esm/locale';

//import htmlToDraft from "html-to-draftjs";
//import { letterSpacing } from "@mui/system"

export default function LedText() {
	const { setting, setSetting } = useProject()
	//const [startDate, setStartDate] = useState();
	//const [endDate, setEndDate] = useState();

	const [editorState, setEditorState] = useState(EditorState.createEmpty());

	const [form, setForm] = useState({
		textno : "", 
		textname : "", 
		scrollspeed : "6",
		scrollspeed2 : "6",
		desc : "", 
		iSecs: 6,
		effect:0,
	})	
	
	// let htmlToDraft = null;
	// if (typeof window === 'object') {
	// 	htmlToDraft = require('html-to-draftjs').default;
	// }
	const htmlToDraft = typeof window === 'object' && require('html-to-draftjs').default;

	useEffect(() => {
		if(setting && setting.ledtext ) {
			setForm({...form, 
				textno : setting.ledtext.textno, 
				textname : setting.ledtext.textname,
				desc : setting.ledtext.desc,
				iSecs: setting.ledtext.iSecs,
				effect: setting.ledtext.effect,
				msg:"",
			})
			//setting.ledtext.stardate ? setStartDate(new Date(setting.ledtext.stardate)):setStartDate(null),
			//setting.ledtext.enddate ? setEndDate(new Date(setting.ledtext.enddate)):setEndDate(null)

			const contentBlock = htmlToDraft( setting.ledtext.html);
		    if (contentBlock) {
				const contentState = ContentState.createFromBlockArray(
				  contentBlock.contentBlocks
				);
				const newEditorState = EditorState.createWithContent(contentState);
				setEditorState(newEditorState);
			}

			setSetting({
				...setting,
				ledtext:null,
			})
		}
	}, [setting && setting.ledtext? setting.ledtext:null]);	

	const dateToString = (date) => {
		return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0')
	}

	const handleChange = (e) =>{
		setForm({
			...form,
			[e.target.name]: e.target.value,
			msg: '',
		})
	}

	const handleSubmit = () => {
		if (
			form.textno === "" ||
			form.textname === ""
		)
			return
		//onClose()
	}

	function getledColor(st,lastclr, lastbk){
		var gb = 0;
		if(st.indexOf("bgcolor") > -1) gb = 1;
		var clr = st.replace("bgcolor-rgb(","");
		var clr = clr.replace("color-rgb(","");
		var clr = clr.replace(")","");
		var rgb = clr.split(",");
		var bRGB = 7;
		if(rgb.length == 3){
			var r = (rgb[0] > 0 ? 4 : 0);
			var g = (rgb[1] > 0 ? 2 : 0);
			var b = (rgb[2] > 0 ? 1 : 0);
			bRGB = r+g+b;
		} 
		var res = bRGB;
		if(gb > 0) res = lastclr*10 + bRGB;
		else       res = bRGB*10 + lastbk;
		return {gb:gb, clr:bRGB, res: res };
	}

	const rawToled = (raw) =>{
		let led = '';
		raw.blocks.map((block,index)=>{
			var text = block.text;
			var chgoffset = 0;
			var lastclr = 7; //white
			var lastbk = 0; //black
			for( var i=0; i<block.inlineStyleRanges.length; i++){
				var ob = block.inlineStyleRanges[i];
				if(i==0 && ob.offset > 0){ 
					text = String(lastclr*10+lastbk) + text; 
					chgoffset += 2;
				}

				var clrobj = getledColor(ob.style, lastclr, lastbk)
				var lastbkclr = lastclr;
				if(lastbk > 0) lastbkclr = lastclr*10+ lastbk;
				var text1 = text.substring(0, ob.offset+chgoffset) + String(clrobj.res) + text.substring( ob.offset+chgoffset, ob.offset+chgoffset+ob.length)
				if( ob.offset+chgoffset+ob.length < text.length){
					text = text1 + String(lastclr*10+lastbk) + text.substring( ob.offset+chgoffset+ob.length);
					chgoffset += 2;
				}
				else text = text1;
				chgoffset += 2;

				if(clrobj.gb > 0 )  lastbk = clrobj.clr;
				else lastclr = clrobj.clr;
			}
			if(index == 0) text = "$1"+text;
			else if(index == 1) text = "$2"+text;
			if(index < 2) led += text;
		})
		return led;
	}

	function getspanColor(rgbtext){
		let tclr = 7;
		let bclr = 0;
		let ltext = '';

		const regex = new RegExp('(?<="color: rgb)(.*?)(?=;)');
		let match = rgbtext.match(regex);
		if(match && match.length > 0){
			var srgb = match[0].replace("(","");
			var srgb = srgb.replace(")","");
			var rgb = srgb.split(",");
			if(rgb.length == 3){
				var r = (rgb[0] > 0 ? 4 : 0);
				var g = (rgb[1] > 0 ? 2 : 0);
				var b = (rgb[2] > 0 ? 1 : 0);
				tclr = r+g+b;
			} 
		}

		const regex1 = new RegExp('(?<=background-color: rgb)(.*?)(?=;)');
		let match1 = rgbtext.match(regex1);
		if(match1 && match1.length > 0){
			var srgb = match1[0].replace("(","");
			var srgb = srgb.replace(")","");
			var rgb = srgb.split(",");
			if(rgb.length == 3){
				var r = (rgb[0] > 0 ? 4 : 0);
				var g = (rgb[1] > 0 ? 2 : 0);
				var b = (rgb[2] > 0 ? 1 : 0);
				bclr = r+g+b;
			} 
		}

		var loc = rgbtext.indexOf(">")
		if(loc > -1) ltext = rgbtext.substring(loc+1);

		return {tclr:tclr,bclr:bclr,ltext:ltext}
		//return String(tclr) + String(bclr) + ltext;
	}

	const htmlToled = (html) =>{
		if(html=="")  return '';
		let data = html.split("\n");
		let ret = '';
		let scrollspeed = form.scrollspeed;
		//if(parseInt(scrollspeed) <=0 ) scrollspeed = "6";
		let scrollspeed2 = form.scrollspeed2;
		//if(parseInt(scrollspeed2) <=0 ) scrollspeed2 = "6";

		for ( var i =0; i<data.length; i++) {
			let led = '';
			let text = data[i];
			if(text != ''){
				const startclr = "70";
				const spd = ((i==0)?scrollspeed:scrollspeed2);
				const regexp = new RegExp('(?<=\<p style=\"text-align:)(.*?)(?=;\">)');
				let matchp = text.match(regexp);
				if(matchp){
					let align = matchp[0];
					if(align == "center" ){
						led = "8"+ spd;
						text = text.substring( matchp.index + align.length + 3);
					} else if(align == "right" ){
						led = "4"+ spd;
						text = text.substring( matchp.index+ align.length  + 3);
					}else if(align == "left" ){
						led = "0"+ spd;
						text = text.substring( matchp.index+ align.length  + 3);
					} else if(align == "justify" ){
						led = "C"+ spd;
						text = text.substring( matchp.index+ align.length  + 3);
					}
				}
				else{
					text = text.replace("<p>","");	
					if(data.length < 3)	led = "2"+ spd;
					else led = "0"+spd					
				}

				const regex = new RegExp('(?<=\<span)(.*?)(?=<\/span>)');
				let match = text.match(regex);
				if(match){
					while(match && match.length > 0){
						let rgbtext = match[0];
						let clrtxt = getspanColor(rgbtext);

						let rem = text.substring( 0, match.index-5);
						let loc = rem.indexOf("<p>");
						if(loc > -1 && rem.length > loc) rem = startclr + rem.substring(loc+3);
						else if(rem.length > 0) rem = startclr + rem;
						
						led = led + rem + clrtxt;
						text = text.substring( match.index + match[0].length + 7);
						match = text.match(regex);
					}
				}

				let loc2 = text.indexOf("</p>");
				if(loc2 > 0 ) led = led + startclr + text.substring(0,loc2);
				
				if(led.length > 0){
					if( i == 0) led = "$1150016"+ led;
					else if( i == 1) led = "$21150016"+ led;
					if( i < 2) ret += led;
				}
			}
		}
		return ret;
	}

	const htmlTohex = (html, raw) =>{ 
		if(html=="")  return '';

		let date = String(form.textno).padEnd(10);
  		let filename = form.textname;//date+".txt"; //파일명
		// let filename = date+".txt"; //파일명

		let text1 = iconv.encode(raw.blocks[0].text, 'euc-kr');
		let text2 = "";
		if(raw.blocks.length > 1 ) text2 = iconv.encode(raw.blocks[1].text, 'euc-kr');
		let flen = Math.max(256, 0x48+text1.length + text2.length + 10);
		if(flen > 256) flen = Math.max(512,0x48+text1.length + text2.length + 10);
		let bytes = new Uint8Array(flen);

		for(let i=0; i<filename.length; i++) bytes[i]=filename.charCodeAt(i) 
		let str1 = "F" + String(form.textno) + "U"
		for(let i=0; i<str1.length; i++) bytes[i+0x10]=str1.charCodeAt(i)  
		bytes[0x20] = Number('0x'+date.substring(2,4)); //날짜
		bytes[0x21] = Number('0x'+date.substring(4,6))
		bytes[0x22] = Number('0x'+date.substring(6,8))
		bytes[0x23] = Number('0x'+date.substring(8,10))
		for(let i=0; i<4; i++) bytes[i+0x26]= 0xFF;
		
		let ts1 = 0x48; //text 시작

		bytes[0x2B]= 0x01; //시나리오1
		bytes[0x41]= ts1;//file loc 
		bytes[0x42]= (form.effect)? parseInt(form.effect):0x00;
		bytes[0x43]= (form.iSecs)? parseInt(form.iSecs):0x1E; //3초	//bytes[0x48]= 0x44;	bytes[0x49]= 0x45; //고정
		bytes[ts1] = 0x54; bytes[ts1+1] = 0x58;//'TX';

		let data = html.split("\n");
		let scrollspeed = parseInt(form.scrollspeed);  //if(parseInt(scrollspeed) <=0 ) scrollspeed = "6";
		let scrollspeed2 = parseInt(form.scrollspeed2);	//if(parseInt(scrollspeed2) <=0 ) scrollspeed2 = "6";

		let bufloc = 0;
		for ( var i =0; i<data.length; i++) {
			let led = '';
			let text = data[i];
			if(text != ''){
				bytes[ts1+4]=0x24; bytes[ts1+5]=0x30 + (i+1); //줄수
				bytes[ts1+6]=0x15; bytes[ts1+7]=0x00; bytes[ts1+8]=0x16;//11단 

				const deftclr = 0x07;
				const defbclr = 0x00;
				const spd = ((i==0)?scrollspeed:scrollspeed2);

				const regexp = new RegExp('(?<=\<p style=\"text-align:)(.*?)(?=;\">)');
				let matchp = text.match(regexp);
				if(matchp){
					let align = matchp[0];
					if(align == "center" ){
						bytes[ts1+9] = 0x80 + spd;
						text = text.substring( matchp.index + align.length + 3);
					} else if(align == "right" ){
						bytes[ts1+9] = 0x40 + spd;
						text = text.substring( matchp.index+ align.length  + 3);
					}else if(align == "left" ){
						bytes[ts1+9] = 0x00 + spd;
						text = text.substring( matchp.index+ align.length  + 3);
					} else if(align == "justify" ){
						bytes[ts1+9] = 0xC0 + spd;
						text = text.substring( matchp.index+ align.length  + 3);
					}
				}
				else{
					text = text.replace("<p>","");	
					bytes[ts1+9] = 0x00+spd;
					//if(data.length < 3)	bytes[ts1+9] = 0x20+ spd;
					//else bytes[ts1+9] = 0x00+spd					
				}

				bufloc = 10;
				const regex = new RegExp('(?<=\<span)(.*?)(?=<\/span>)');
				let match = text.match(regex);
				if(match){
					while(match && match.length > 0){
						let rgbtext = match[0];
						let clrtxt = getspanColor(rgbtext);
						
						let rem = text.substring( 0, match.index-5);
						let loc = rem.indexOf("<p>");
						if(loc > -1 && rem.length > loc){ //포멧없는 앞글자
							bytes[ts1+bufloc++]=deftclr;
							bytes[ts1+bufloc++]=defbclr;
							rem = rem.substring(loc+3);
							const brem = iconv.encode(rem, 'euc-kr');
							for(var j=0; j< brem.length; j++) bytes[ts1+bufloc++]=brem[j]
						}
						else if(rem.length > 0){
							bytes[ts1+bufloc++]=deftclr;
							bytes[ts1+bufloc++]=defbclr;
							const brem = iconv.encode(rem, 'euc-kr');
							for(var j=0; j< brem.length; j++) bytes[ts1+bufloc++]=brem[j]
						}

						bytes[ts1+bufloc++]=clrtxt.tclr;
						bytes[ts1+bufloc++]=clrtxt.bclr;
						const bclrtext = iconv.encode(clrtxt.ltext, 'euc-kr');
						for(var j=0; j< bclrtext.length; j++) bytes[ts1+bufloc++]=bclrtext[j]
						
						text = text.substring( match.index + match[0].length + 7);
						match = text.match(regex);
					}
				}

				let loc2 = text.indexOf("</p>");
				if(loc2 > 0 ){
					bytes[ts1+bufloc++]=deftclr;
					bytes[ts1+bufloc++]=defbclr;
					const brem2 = iconv.encode(text.substring(0,loc2), 'euc-kr');
					for(var j=0; j< brem2.length; j++) bytes[ts1+bufloc++]=brem2[j]
				}

				bytes[ts1+bufloc++] = 0x16;
				if(i==0) ts1 += Math.max(0,bufloc-4);
			}
		}
		bytes[ts1+bufloc++] = 0x0D; bytes[ts1+bufloc++]=0x0A; //종료
		return bytes;
	}

	const htmlTohex2 = (html, raw) =>{
		if(html=="")  return '';

		let date = String(form.textno).padEnd(10);
  		//let filename = "FSYSTEMU";//date+".txt"; //파일명
		let filename = date+".txt"; //파일명

		let text1 = iconv.encode(raw.blocks[0].text, 'euc-kr');
		let text2 = "";
		if(raw.blocks.length > 1 ) text2 = iconv.encode(raw.blocks[1].text, 'euc-kr');
		let flen = Math.max(256, 8 + 0x48+text1.length + text2.length);
		if(flen > 256) flen = Math.max(512,0x48+text1.length + text2.length);

		let bytes = new Uint8Array(flen);
		for(let i=0; i<filename.length; i++) bytes[i]=filename.charCodeAt(i) 
		let str1 = "F0U";//F" +date + ((businfo.dir==2)?"D":"U");"
		for(let i=0; i<str1.length; i++) bytes[i+0x10]=str1.charCodeAt(i)  
		bytes[0x20] = Number('0x'+date.substring(2,4)); //날짜
		bytes[0x21] = Number('0x'+date.substring(4,6))
		bytes[0x22] = Number('0x'+date.substring(6,8))
		bytes[0x23] = Number('0x'+date.substring(8,10))
		for(let i=0; i<4; i++) bytes[i+0x26]= 0xFF;
		
		let ts1 = 0x48; //text 시작

		bytes[0x2B]= 0x01; //시나리오1
		bytes[0x41]= ts1;//file loc 
		bytes[0x42]= (form.effect)? parseInt(form.effect):0x00;
		bytes[0x43]= (form.iSecs)? parseInt(form.iSecs):0x1E; //3초	//bytes[0x48]= 0x44;	bytes[0x49]= 0x45; //고정
		bytes[ts1] = 0x54; bytes[ts1+1] = 0x58;//'TX';

		let data = html.split("\n");
		let scrollspeed = parseInt(form.scrollspeed);  //if(parseInt(scrollspeed) <=0 ) scrollspeed = "6";
		let scrollspeed2 = parseInt(form.scrollspeed2);	//if(parseInt(scrollspeed2) <=0 ) scrollspeed2 = "6";

		let bufloc = 0;
		for ( var i =0; i<data.length; i++) {
			let led = '';
			let text = data[i];
			if(text != ''){
				bytes[ts1+4]=0x24; bytes[ts1+5]=0x30 + (i+1); //줄수
				bytes[ts1+6]=0x15; bytes[ts1+7]=0x00; bytes[ts1+8]=0x16;//11단 

				const deftclr = 0x07;
				const defbclr = 0x00;
				const spd = ((i==0)?scrollspeed:scrollspeed2);

				const regexp = new RegExp('(?<=\<p style=\"text-align:)(.*?)(?=;\">)');
				let matchp = text.match(regexp);
				if(matchp){
					let align = matchp[0];
					if(align == "center" ){
						bytes[ts1+9] = 0x80 + spd;
						text = text.substring( matchp.index + align.length + 3);
					} else if(align == "right" ){
						bytes[ts1+9] = 0x40 + spd;
						text = text.substring( matchp.index+ align.length  + 3);
					}else if(align == "left" ){
						bytes[ts1+9] = 0x00 + spd;
						text = text.substring( matchp.index+ align.length  + 3);
					} else if(align == "justify" ){
						bytes[ts1+9] = 0xC0 + spd;
						text = text.substring( matchp.index+ align.length  + 3);
					}
				}
				else{
					text = text.replace("<p>","");	
					bytes[ts1+9] = 0x00+spd;
					//if(data.length < 3)	bytes[ts1+9] = 0x20+ spd;
					//else bytes[ts1+9] = 0x00+spd					
				}

				bufloc = 10;
				const regex = new RegExp('(?<=\<span)(.*?)(?=<\/span>)');
				let match = text.match(regex);
				if(match){
					while(match && match.length > 0){
						let rgbtext = match[0];
						let clrtxt = getspanColor(rgbtext);
						
						let rem = text.substring( 0, match.index-5);
						let loc = rem.indexOf("<p>");
						if(loc > -1 && rem.length > loc){ //포멧없는 앞글자
							bytes[ts1+bufloc++]=deftclr;
							bytes[ts1+bufloc++]=defbclr;
							rem = rem.substring(loc+3);
							const brem = iconv.encode(rem, 'euc-kr');
							for(var j=0; j< brem.length; j++) bytes[ts1+bufloc++]=brem[j]
						}
						else if(rem.length > 0){
							bytes[ts1+bufloc++]=deftclr;
							bytes[ts1+bufloc++]=defbclr;
							const brem = iconv.encode(rem, 'euc-kr');
							for(var j=0; j< brem.length; j++) bytes[ts1+bufloc++]=brem[j]
						}

						bytes[ts1+bufloc++]=clrtxt.tclr;
						bytes[ts1+bufloc++]=clrtxt.bclr;
						const bclrtext = iconv.encode(clrtxt.ltext, 'euc-kr');
						for(var j=0; j< bclrtext.length; j++) bytes[ts1+bufloc++]=bclrtext[j]
						
						text = text.substring( match.index + match[0].length + 7);
						match = text.match(regex);
					}
				}

				let loc2 = text.indexOf("</p>");
				if(loc2 > 0 ){
					bytes[ts1+bufloc++]=deftclr;
					bytes[ts1+bufloc++]=defbclr;
					const brem2 = iconv.encode(text.substring(0,loc2), 'euc-kr');
					for(var j=0; j< brem2.length; j++) bytes[ts1+bufloc++]=brem2[j]
				}

				bytes[ts1+bufloc++] = 0x16;
				if(i==0) ts1 += Math.max(0,bufloc-4);
			}
		}
		bytes[ts1+bufloc++] = 0x0D; bytes[ts1+bufloc++]=0x0A; //종료
		return bytes;
	}

	const handleApply = async (event, value) => {
		event.preventDefault();

		var content = editorState.getCurrentContent();
		var raw = convertToRaw(content)
		var html = draftToHtml(raw)
		var bytes = htmlTohex(html, raw) 
		
		const link = document.createElement( 'a' );
		link.style.display = 'none';
		document.body.appendChild( link );

		const blob = new Blob( [ bytes ], { type: 'application/octet-stream' } )
		link.href = URL.createObjectURL( blob );
		link.download = form.textno + ".ebs";
		link.click();
	}

	const handleAddledtext = async (event, value) => {
		event.preventDefault();

		if ( !(parseInt(form.textno) > 0) ){
			setForm({
				...form,
				msg: "ID 를 입력하세요"
			})
			return
		}

		const token = localStorage.getItem('accessToken');
		if (token === null) {
			alert('로그인 해주세요!');
			//router.push('/');
		}

		var content = editorState.getCurrentContent();
		var raw = convertToRaw(content)
		var html = draftToHtml(raw)
		var ledstr = htmlTohex(html, raw)

		var desc = raw.blocks[0].text; 
		if(raw.blocks.length > 1 ) desc = desc +"\n"+ raw.blocks[1].text; 

		var ob = {};
        ob.textno = parseInt(form.textno);
        ob.textname = form.textname;
		ob.desc = desc;
        ob.filename = form.textname + ".txt";
		ob.lat = '';
		ob.lng = '';
		ob.speed1 = form.scrollspeed;
		ob.speed2 = form.scrollspeed2;
		ob.html = html;
		//ob.ledtext = Buffer.from(ledstr.buffer, 'base64');
		ob.ledtext = btoa(ledstr.buffer);
		ob.iSecs = form.iSecs;
		ob.effect = form.effect;

        console.log(ob);

		try {
			const resp = await axios.post(`${process.env.REACT_APP_PUBLIC_API_URL}/texts`,
			{
				ob
			},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
			setForm({
				...form,
				msg: resp.data.message
			})

			setSetting({
				...setting,
				textchg : 1,
			})
			
		} catch (err) {
			alert(err);
		}
	};

	const handleDelledtext = async (event, value) => {
		event.preventDefault();

		if (
			form.textno === "0" ||
			form.textno === ""
		)return

		const token = localStorage.getItem('accessToken');
		if (token === null) {
			alert('로그인 해주세요!');
			//router.push('/');
		}
		try {
			const resp = await axios.delete(`${process.env.REACT_APP_PUBLIC_API_URL}/texts`,{
				data : {
					textno : form.textno
				},
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
			if (resp.data.ok) {
				setForm({
					...form,
					msg: '삭제되었습니다'
				})

				setSetting({
					...setting,
					textchg : 1,
				})
			} else {
				setForm({
					...form,
					msg: resp.data.message
				})
			}
		} catch (err) {
			alert(err);
		}
	};

	// const SDatePicker = styled(DatePicker)`
	// 	width:125px;
	// 	height:30px;
	// 	box-sizing:border-box;
	// 	border-radius:4px;
	// 	font-size:14px;
	// 	background-color:#474747;
	// 	padding:6px;
	// 	border:1px solid;
	// `;

	return (
		<div className = {style.defaultModal} style={{ display: 'flex', marginLeft:'10px', marginTop: '50px'}}>
		<div style={{  flex: '50%', marginLeft:'20px',marginTop:'10px'}}>	
		<div className={style.wrapper2} style={{width:'570px',height:"520px"}}>
				<label className={style.linecs} style={{marginTop:'-8px'}}>LED Text Editor</label>
				{/* <div style={{marginTop:'20px'}}> 
				<label className={style.label} style={{marginLeft:'-8px'}}>Region : </label>
				<input
						className={style.input} type='text' name='region' placeholder='region'
						style={{ width: '100px', marginLeft:'8px',marginBottom:'5px'}}
						maxLength='16' value={form.region} onChange={handleChange} spellCheck="false"
				/>
				<label className={style.label} style={{marginLeft:'-8px'}}>Company : </label>
				<input
						className={style.input} type='text' name='company'	placeholder='company'
						style={{ width: '100px', marginLeft:'-9px',marginBottom:'20px'}}
						maxLength='16' value={form.company} onChange={handleChange} spellCheck="false"
				/>
				</div> */}
				<div style={{marginTop:'30px'}}>
				<label className={style.label}>ID</label>
				<input style={{width:'100px'}}
					className={style.input}	type='text'
					name='textno'	placeholder='ID'
					maxLength='16'		value={form.textno}
					onChange={handleChange}		spellCheck="false"
				/>						
				<label className={style.label}>Text Name</label>
				<input
					className={style.input}	name='textname'
					placeholder='textname'	maxLength='16'
					value={form.textname} onChange={handleChange}
					spellCheck="false" style={{ width: '120px'}}
				/>
				{/* <label className={style.label}>File Name</label>
				<input
				className={style.input}
					name='filename'
					placeholder='filename'
					maxLength='16'
					value={form.filename}
					onChange={handleChange}
					spellCheck="false"
					style={{ width: '100px'}}
				/>*/}
				</div>
				<div  style={{height:'160px'}}>
					<div style={{ marginLeft : '10px',marginTop: '10px', width:'550px'}}>
					<LedEditor
						editorState={editorState}
						setEditorState={setEditorState}
					/>
					</div>
				 	<div style={{ marginTop: '10px'}}>
					<label className={style.label} >1Row Scroll Speed</label>
					<input
					className={style.input}
						style={{ width: '50px'}}
						type='text'
						name='scrollspeed'
						placeholder='속도'
						maxLength='16'
						value={form.scrollspeed}
						onChange={handleChange}
						spellCheck="false"
					/>
					<label >2Row Scroll Speed</label>
					<input
					className={style.input}
						style={{ width: '50px'}}
						type='text'
						name='scrollspeed2'
						placeholder='속도'
						maxLength='16'
						value={form.scrollspeed2}
						onChange={handleChange}
						spellCheck="false"
					/>
					</div>
					<div>
					<label >Display Time</label>
					<input
					className={style.input}
						type='text'
						name='iSecs'
						placeholder='재생시간'
						maxLength='16'
						value={form.iSecs}
						onChange={handleChange}
						spellCheck="false"
						style={{marginLeft:'10px',width:'60px', marginRight:'15px'}}
					/>
					<label className={style.label} >Display Effect</label>
					<select
						style={{width: '170px',height:'35px'}}
						className={style.canvasTemplate}
						name='effect'
						onChange={handleChange}
						value={form.effect}
					>
						<option value={0}>None</option>
						<option value={1}>Flash</option>
						<option value={2}>Color Reversal</option>
						<option value={3}>Move Bottom</option>
						<option value={4}>Move Top</option>
						<option value={5}>Move Right</option>
						<option value={6}>Move Left</option>
					</select>		
					</div> 
				</div>
				{/* <div className={style.modalMid} style={{marginTop:'10px',width:'365px', marginLeft:'0px'}}>
					<label style={{width:'150px',marginRight:'10px'}}>방송기간</label>
					<SDatePicker dateFormat="yyyy년 MM월 dd일"
							selected={startDate} onChange={date => setStartDate(date)}
					/>
					<p>&nbsp;_&nbsp;</p>
					<SDatePicker dateFormat="yyyy년 MM월 dd일"
							selected={endDate} onChange={date => setEndDate(date)}
					/>
				</div> */}
				<div style={{marginTop:'100px',marginLeft:'20px'}}>
					<button className={style.button} onClick={handleAddledtext}>Save</button>
					<button className={style.button} onClick={handleDelledtext}>Delete</button>
					<button className={style.button} onClick={handleApply}>File</button>
				</div>
				<label className={style.label} style={{ color:"#C3602C", marginTop:"0px"}} value={form.msg}>{form.msg}</label>
			</div>
			</div>
			<div style={{  flex: '50%', marginLeft:'20px'}}>	
				{<ControlPanel menu="text" />}
			</div>
		</div>
	)
}
